<template>
  <div>
    <transition name="slide-fade">
      <slot name="body" v-if="isShow"></slot>
    </transition>

    <div v-if="! isShow">
      <div class="link">
        <span @click="clickOpenLink">
            Продолжение <span class="arrow open_arrow">&#8250;</span>
        </span>
      </div>
    </div>

    <div v-if="isShow">
      <div class="link">
        <span @click="clickOpenLink">
          Свернуть <span class="arrow close_arrow">&#8250;</span>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "Accordion",
  data: function () {
    return {
      isShow: false
    }
  },
  methods: {
    clickOpenLink() {
      this.isShow = !this.isShow;
    },
  }
}
</script>

<style lang="scss" scoped>
@import "../../scss/components/accordion";

.link {
  font-size: 12px;
  margin: 3px 0;

  & i {
    color: #999;
    text-decoration: none !important;
  }

  & span {
    cursor: pointer;
    &:hover {
      text-decoration: underline;
    }
  }

  @media screen and (max-width: 575.98px) {
    margin: 14px 0;
    text-align: center;
    text-decoration: none;

    &:hover {
      text-decoration: none;
    }
  }
}

.arrow {
  display: inline-block;
  margin-left: 3px;
  text-decoration: none !important;
}

.open_arrow {
  transform: rotate(90deg);
}

.close_arrow {
  transform: rotate(-90deg);
}

</style>